import type { Deck } from '@/framework/types';
import { slides } from './slides';

const deck: Deck = {
  slug: 'orca-intro',
  category: 'event-talks',
  title: 'Orca 101: An Intro to Orca Agent Engine',
  speaker: 'Sijie Guo',
  description:
    'A 40-minute intro ahead of the hackathon tutorial, for a room new to Orca: what Orca Agent Engine is, its resources and its API, and how to build an agent on it.',
  date: '2026-10-07',
  context: 'Data + Agent Hackathon · Data Streaming Summit 2026 · San Francisco',
  visibility: 'public',
  slides,
};

export default deck;
